import(/* webpackMode: "eager" */ "/root/repo/src/app/(services)/resume-writing/submit-resume/page.tsx");
